import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";

export const StyledExpandIconButton = styled(IconButton)`
    ${SWReactIcons} {
        & svg path {
            fill: ${colorsPalettes.carbon[300]};
        }
    }
`;
